import { useQuery, useMutation } from '@tanstack/react-query'
import { followUpApi } from '../lib/api'
import type { CutFollowUpRoutesRequest, FollowUpKind } from '../types/followUp'

// CF-1 P2 contract. Cut/recut return { jobId } at 202-accept: callers poll the job and invalidate
// ['followUp', campaignId] only on Succeeded (job-polling rules), so the mutations invalidate nothing.

export function useFollowUpRoutes(campaignId: string, kind: FollowUpKind, customKindId?: string | null) {
  return useQuery({
    queryKey: ['followUp', campaignId, 'routes', kind, customKindId ?? null],
    queryFn: () => followUpApi.getRoutes(campaignId, { kind, customKindId }).then(r => r.data),
    enabled: !!campaignId,
  })
}

export function useCutFollowUpRoutes(campaignId: string) {
  return useMutation({
    mutationFn: (body: CutFollowUpRoutesRequest) =>
      followUpApi.cutRoutes(campaignId, body).then(r => r.data),
  })
}

export function useRecutFollowUpBatch(campaignId: string) {
  return useMutation({
    mutationFn: ({ turfMapId, driverCount }: { turfMapId: string; driverCount: number }) =>
      followUpApi.recutBatch(campaignId, turfMapId, { driverCount }).then(r => r.data),
  })
}
